import { Grid, Box, Typography } from "@mui/material";
import Editor from "../components/Editor/Editor.js";
import Window from "../components/Window/Window.js";
import Requirements from "../components/Requirements.js";
import QuestionNav from "../components/Buttons/QuestionNav.js";
import AssignmentNav from "../components/Buttons/AssignmentNav.js";
import SaveButton from "../components/Buttons/SaveButton.js";
import SubmitButton from "../components/Buttons/SubmitButton.js";
import RestartButton from "../components/Buttons/RestartButton.js";

export const Home = ({ setPage }) => {
  return (
    <>
      <Grid container direction="row" sx={{ paddingTop: "70px", px: "15px" }}>
        <Grid container item direction="column" xs={6}>
          <Grid container item direction="row">
            <Grid item xs={6} container justifyContent="flex-start">
              <QuestionNav />
            </Grid>

            <Grid item container xs={6} justifyContent="flex-end">
              <Box sx={{ display: "flex" }}>
                <RestartButton />

                <SaveButton setPage={setPage} />

                <SubmitButton setPage={setPage} />
              </Box>
            </Grid>
          </Grid>
          <Grid item sx={{ height: "60vh", paddingTop: "25px" }}>
            <Editor />
          </Grid>
          <Grid item>
            <Requirements setPage={setPage} />
          </Grid>
        </Grid>
        <Grid item xs={6} sx={{ height: "80vh" }}>
          <Typography variant="h5" align="center">
            Code Preview
          </Typography>
          <Window />
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        sx={{ paddingTop: "70px", px: "15px" }}
      >
        <Grid
          item
          xs={2}
          container
          justifyContent="left"
          sx={{ display: "flex" }}
        ></Grid>
        <Grid item xs={10}>
          <Grid
            container
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              container
              item
              direction="column"
              xs={6}
              alignItems="center"
              justifyContent="center"
              //sx={{ height: "80vh", maxWidth: "50vw" }}
              spacing={0}
            >
              <Grid
                item
                container
                xs={9}
                //sx = {{maxHeight: "58vh", maxWidth: "50vw"}}
              ></Grid>
              <Grid item container xs={3}></Grid>
            </Grid>
            <Grid
              container
              item
              xs={6}
              alignItems="center"
              justifyContent="center"
            ></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Home;
